import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import AboutStore from '../store/AboutStore';
import HomeStore from '../store/HomeStore';
import OtherStore from '../store/OtherStore';

export const store = configureStore({
  reducer: {
    home: HomeStore,
    about: AboutStore,
    other: OtherStore,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
